import { DecisionContext, DecisionTypeHandler, DbotEventDispatcher } from "../common/commonDomain";
import {
  ConvertibleLoanPowerOfAttorney,
  ConvertibleLoanPowerOfAttorneyForm,
} from "./convertibleLoanPoADomain";
import { DecisionType } from "../../common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext,
  data?: ConvertibleLoanPowerOfAttorney,
): ConvertibleLoanPowerOfAttorneyForm {
  return new ConvertibleLoanPowerOfAttorneyForm(context, data);
}

export function applyForm(
  form: ConvertibleLoanPowerOfAttorneyForm,
): ConvertibleLoanPowerOfAttorney {
  return {
    type: DecisionType.convertibleLoanPowerOfAttorney,
    convertibleLoanValue: form.convertibleLoanValue.parsedValue ?? 0,
    convertibleLoanCapitalShareValue: form.convertibleLoanCapitalShareValue.parsedValue ?? 0,
    convertibleLoanDuration: form.convertibleLoanDuration.value,
    convertibleLoanDeviateFromShareholderRights:
      form.convertibleLoanDeviateFromShareholderRights.value ?? false,
    convertibleLoanShareTypes: form.convertibleLoanShareTypes.selected.filter((s) => s !== "all"),
    isConvertibleLoanAllShareTypes: form.isAllShareTypesSelected,
    convertibleLoanNewShareType: form.convertibleLoanNewShareType.value ?? false,
    convertibleLoanNewShareTypeDescription:
      form.convertibleLoanNewShareTypeDescription.validatedValue,
    convertibleLoanReason: form.convertibleLoanReason.validatedValue,
    convertibleLoanDurationMonths: form.convertibleLoanDurationMonths.parsedValue,
  };
}

export function validate(form: ConvertibleLoanPowerOfAttorneyForm): boolean {
  return form.validate();
}

export function isValid(form: ConvertibleLoanPowerOfAttorneyForm): boolean {
  return form.isValid;
}

export const convertibleLoanPoAHandler: DecisionTypeHandler<
  DecisionType.convertibleLoanPowerOfAttorney,
  ConvertibleLoanPowerOfAttorney,
  ConvertibleLoanPowerOfAttorneyForm
> = {
  type: DecisionType.convertibleLoanPowerOfAttorney,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
